import React, { Component } from "react";
import PropTypes from "prop-types";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import {
  Paper,
  Grid,
  Button,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";

import Header from "../../../partials/header";
import InputFormat from "../../../partials/inputForm";
import Loading from "../../loading";
import Snackbar from "../../snackbar";
import MediaUpload from "../mediaUpload";
import { styles } from "./styles";

class CreateDigital extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        isActive: 1,
      },
    };
  }
  handleAddMedia = (index) => {
    this.uploadMedia.handleAddMedia(index);
  };
  handleChange = (event) => {
    let { data } = this.state;
    let name = event.target.name;
    let value = event.target.value;
    if (event.target.type === "checkbox") {
      value = event.target.checked ? 1 : 0;
    }
    data[name] = value;
    this.setState({ data });
  };
  handleSubmit = async () => {
    const _this = this;
    let { t } = this.props;
    let { data } = this.state;
    if (data.title) {
      let arrayMedia = this.uploadMedia.getListMedia();
      arrayMedia = arrayMedia.filter((item) => !!item.data);
      let media = [];
      this.loading.startLoading();
      if (arrayMedia.length) {
        for (let i = 0; i < arrayMedia.length; i++) {
          let ele = arrayMedia[i];
          let checkUpload = await this.props.saveStorage({
            files: ele.file,
            code: this.props.serviceCode,
            type: "digital-signal",
          });
          if (checkUpload.code === 1)
            media.push({
              mediaURL: checkUpload.data.previewLink,
              mediaLength: ele.time || 3,
              mediaName: ele.file.name,
              mediaType: ele.file.type,
            });
        }
      }
      data.media = media;
      let check = await this.props.create(data);
      if (check.code === 1) {
        this.mSnackbar.handleClick(t("create_degital_signal_success"));
        setTimeout(function () {
          _this.props.history.push("/digital/list");
        }, 3000);
      } else {
        this.mSnackbar.handleClick(
          `${t("create_degital_signal_unsuccess")} ${check.error} \n
          Message: ${check.message}`,
          "error"
        );
      }
      this.loading.stopLoading();
    } else {
      this.mSnackbar.handleClick(
        t("create_degital_signal_pls_insert_title"),
        "warning"
      );
    }
  };
  render() {
    const { t, history, classes, theme } = this.props;
    const { data } = this.state;
    return (
      <React.Fragment>
        <Header
          session={t("digital_signal_title_list")}
          title={t("digital_signal_title_create")}
          backIcon={true}
          actionBack={() => history.push("/digital/list")}
        />
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Loading onRef={(id) => (this.loading = id)} />
        <Paper className={classes.root}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12}>
              <InputFormat
                required
                label={t("digital_signal_create_title")}
                name="title"
                value={data.title}
                onChange={this.handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <InputFormat
                label={t("digital_signal_create_description")}
                name="description"
                multiline
                value={data.description}
                onChange={this.handleChange}
              />
            </Grid>
            <Grid item xs={4} sm={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={data.isActive === 1 ? true : false}
                    name="isActive"
                    onChange={this.handleChange}
                  />
                }
                className={classes.label}
                label={t("digital_signal_create_is_active")}
              />
            </Grid>
            <Grid item xs={4} sm={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={data.showOnShop === 1 ? true : false}
                    name="showOnShop"
                    onChange={this.handleChange}
                  />
                }
                className={classes.label}
                label={t("digital_signal_create_show_on_show")}
              />
            </Grid>
            <Grid container item xs={12} sm={12} justify="flex-end">
              <Button
                variant={"contained"}
                color={"primary"}
                onClick={() => this.handleAddMedia(-1)}
              >
                {t("digital_signal_create_add_media")}
              </Button>
            </Grid>
          </Grid>
        </Paper>
        <MediaUpload onRef={(media) => (this.uploadMedia = media)} />
        <div className={classes.btnFooter}>
          <Button
            variant={"contained"}
            color={"primary"}
            onClick={this.handleSubmit}
          >
            {t("digital_signal_create")}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
CreateDigital.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  serviceCode: state.user.user.roleId.serviceCode,
});
const mapDispatch = (dispatch) => ({
  create: dispatch.digitalSignal.create,
  saveStorage: dispatch.upload.saveStorage,
});
export default translate("translations")(
  withStyles(styles, { withTheme: true })(
    connect(mapState, mapDispatch)(CreateDigital)
  )
);
